import './index.scss';

import { useEffect, useState } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';

export type UserAvatarProps = {
  size?: number;
  className?: string;
  src?: string;
  alt?: string;
  initials?: string;
  name?: string;
};

const getInitials = (name?: string): string => {
  const nameParts =
    name
      ?.trim()
      .split(/\s+/)
      .filter((part) => part !== '-') ?? [];

  if (nameParts.length === 0) {
    return '';
  }

  if (nameParts.length === 1) {
    return nameParts[0].slice(0, 2).toLocaleUpperCase('tr-TR');
  }

  return `${nameParts[0].charAt(0)}${nameParts.at(-1)?.charAt(0) ?? ''}`.toLocaleUpperCase('tr-TR');
};

export const UserAvatar = ({ size = 40, className, src, alt, initials, name }: UserAvatarProps) => {
  const trimmedSrc = src?.trim();
  const trimmedInitials = initials?.trim() || getInitials(name);
  const [hasImage, setHasImage] = useState(Boolean(trimmedSrc));

  useEffect(() => {
    setHasImage(Boolean(trimmedSrc));
  }, [trimmedSrc]);

  const showInitials = !hasImage && Boolean(trimmedInitials);
  const avatarClassName = [
    'c-user-avatar',
    showInitials ? 'c-user-avatar--initials' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  const initialsStyle = showInitials
    ? { fontSize: Math.max(10, Math.round(size * 0.3)), lineHeight: 1 }
    : undefined;
  const handleImageError = () => {
    setHasImage(false);
    return false;
  };

  return (
    <Avatar
      size={size}
      className={avatarClassName}
      style={initialsStyle}
      src={hasImage ? trimmedSrc : undefined}
      alt={hasImage ? alt : undefined}
      onError={trimmedSrc ? handleImageError : undefined}
      icon={
        !hasImage && !showInitials ? (
          <UserOutlined style={{ fontSize: Math.max(16, Math.round(size * 0.42)) }} />
        ) : undefined
      }
    >
      {showInitials ? trimmedInitials : null}
    </Avatar>
  );
};
